import React from 'react';
import ReactDOM from 'react-dom';
import { StyleRoot } from 'radium';
import App from './App';
import './base.css';

ReactDOM.render(
  <StyleRoot>
    <App />
  </StyleRoot>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js